module.exports = __webpack_public_path__ + "static/media/trial1-after-10-sek-if-unanswered.d8b6a4a0.mp3";